import { configureStore } from "@reduxjs/toolkit";
import adminDataReducer from "./adminDataSlice";

export const store = configureStore({
  reducer: {
    adminData: adminDataReducer,
  },
});
